import axios from "axios";
import { STRIPE_CHECKOUT_URL, getUserProfile } from "api";

export const createCheckoutSession = ({ plan, prices }) => axios.post(STRIPE_CHECKOUT_URL, { plan, prices });

export const PLANS = {
    FREE: "FREE",
    PRO: "PRO",
    TEAM: "TEAM",
    ENTERPRISE: "ENTERPRISE",
    OPTM: "OPTM",
    INSIGHTS: "INSIGHTS",
};

export const BILLING_FREQUENCY = {
    YEAR: "year",
    MONTH: "month",
};

const normalizeSubscriptionResponse = (data = {}) => {
    const subscriptions = Array.isArray(data.subscriptions)
        ? data.subscriptions
        : Array.isArray(data.results)
        ? data.results
        : data?.id
        ? [data]
        : [];

    const products = Array.isArray(data.products) ? data.products : [];

    return {
        ...data,
        subscriptions,
        products,
        results: Array.isArray(data.results) ? data.results : subscriptions,
        count: data.count ?? subscriptions.length,
    };
};

// Dedupe concurrent requests: loadPlans/loadProducts/loadSubscription all hit this endpoint
// on mount in the same tick. While a request is in flight, share its promise so they collapse
// into a single network call. The promise is cleared once it settles, so later refreshes
// (e.g. after checkout) still fetch fresh data.
let pendingCurrentSubscription = null;

const getCurrentSubscriptionData = async () => {
    if (pendingCurrentSubscription) {
        return pendingCurrentSubscription;
    }
    pendingCurrentSubscription = axios
        .get("users/subscription/current")
        .then(({ data }) => data)
        .finally(() => {
            pendingCurrentSubscription = null;
        });
    return pendingCurrentSubscription;
};

const getCurrentSubscriptionNormalized = async () => {
    const data = await getCurrentSubscriptionData();
    return normalizeSubscriptionResponse(data);
};

export const getProducts = async () => {
    const normalized = await getCurrentSubscriptionNormalized();

    if (normalized.products.length) {
        return {
            ...normalized,
            results: normalized.products,
            count: normalized.products.length,
        };
    }

    const response = await axios.get("users/product");
    return response.data;
};

export const getPlans = async () => {
    const normalized = await getCurrentSubscriptionNormalized();

    return {
        ...normalized,
        results: normalized.subscriptions,
        count: normalized.subscriptions.length,
    };
};

export const getCurrentSubscription = async () => {
    return getCurrentSubscriptionData();
};

export const getStripePortalUrl = async () => {
    const { id } = await getUserProfile();
    const response = await axios.post(`/users/profiles/${id}/get_stripe_portal_url`);
    return response.data;
};

export default {
    createCheckoutSession,
    getCurrentSubscription,
    getStripePortalUrl,
    getPlans,
    getProducts,
};
